export default __webpack_public_path__ + "static/media/9.fa5ae258.jpg";